import(/* webpackMode: "eager" */ "/work/repo/app/[locale]/blog/components/BlogCardWide.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/app/[locale]/pricing/components/PricingOfferButton.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/app/[locale]/solutions/government/components/SectionBook.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/app/[locale]/solutions/government/components/SectionChatbot.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/app/[locale]/solutions/government/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/common/components/BackgroundVideo.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/common/components/FAQCollapse.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/common/components/SectionWrapper.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/common/components/SectionFAQ.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/work/repo/node_modules/next/dist/client/image-component.js");
